import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLink, UitkLinkAlign, UitkLinkTypeSize } from 'uitk-react-link';
import { ActivityBannerType } from '../../../common/__generated__/api';
import { useStores } from '../../../utils/hooks';
import { getBannerByType } from '.';

export const SortDisclaimerBanner: React.FC<{}> = (): JSX.Element | null => {
  const { activitySearchStore, analytics } = useStores();
  const banners = getBannerByType(activitySearchStore, ActivityBannerType.INFO);

  if (!banners || banners.length <= 0) {
    return null;
  }

  const iconSize = banners[0].icon?.size && UitkIconSize[banners[0].icon?.size];

  const handleClick = (): void => {
    analytics.trackEvent(banners[0].action?.rfrr, 'disclaimer-clicked', analytics.omnitureData, null, true);
  };

  return (
    <UitkLink type={UitkLinkTypeSize.SMALL} iconPos={UitkLinkAlign.RIGHT} onClick={handleClick} inline>
      <a data-testid="sort-disclaimer-banner--link" href={banners[0].action?.href} target="_self">
        {banners[0].title && <span className="uitk-type-paragraph-200">{banners[0].title}</span>}
        {banners[0].icon && (
          <UitkIcon
            id={banners[0].icon?.id}
            name={banners[0].icon?.id}
            size={iconSize || UitkIconSize.SMALL}
            description={banners[0].icon?.description}
          />
        )}
      </a>
    </UitkLink>
  );
};
